import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { isArray } from 'lodash';
import { customStyles } from '../../helper';

export function SourceSetting({ obj, updateSetting }) {
  const { t } = useTranslation('common');
  const reducer = useSelector((reducerstate) => reducerstate);
  const { SystemMastersDetails } = reducer;

  const { productIdentifierList } = SystemMastersDetails;
  const [isLengthEnabled, setIsLengthEnabled] = useState(true);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('loggedInUserInfo'));
    console.log('user========> ', user);
    if (user?.lengthVisible !== undefined && user?.lengthVisible !== null) {
      setIsLengthEnabled(user?.lengthVisible);
    }
  }, []);
  let productIdentifierOption = [];

  if (!isLengthEnabled) {
    productIdentifierOption = productIdentifierList?.filter((ele) => ele?.name !== 'Length');
  } else {
    productIdentifierOption = productIdentifierList;
  }

  const locationOption = [{ label: 'Product Identifier', value: 'productIdentifier' }];
  const productIdentifierOutput = [{ label: 'Value', value: 'value' }];

  useEffect(() => {
    if (obj && obj?.moduleName === 'productIdentifier' && obj?.relation && (!obj?.relation?.hasOwnProperty('output') || obj.relation?.output === 'value')) {
      obj.relation.output = { label: 'Value', value: 'value' };
    }
  }, [obj]);

  const handleSelect = (value, key) => {
    const objData = obj;
    objData.relation = objData.relation || {};
    switch (key) {
      case 'location':
        objData.moduleName = value?.value;
        objData.relation[key] = isArray(value) ? value : value.value || value?._id;
        break;
      case 'subLocation':
        objData.relation[key] = value?._id;

        objData.relation.tab = null;
        objData.relation.control = null;

        break;
      case 'tab':
        objData.relation[key] = value?._id;
        objData.relation.control = null;
        break;
      case 'output':
        objData.relation[key] = value;
        break;
      default:
        objData.relation[key] = value?._id;
        break;
    }
    updateSetting(objData);
  };

  return (
    <>
      <div className="common-react-select">
        <p className="field-name">
          {t('DPP.CONTROL.DAM.LOCATION')} <span className="asterisk">*</span>
        </p>

        <Select
          placeholder={t('DPP.CONTROL.SOURCE.SELECT_LOCATION')}
          options={locationOption}
          styles={customStyles}
          className="common-select"
          classNamePrefix="common-select"
          getOptionLabel={({ label }) => `${label}`}
          getOptionValue={({ value }) => `${value}`}
          value={locationOption?.find((ele) => ele?.value === obj?.relation?.location) || null}
          onChange={(selected) => handleSelect(selected, 'location')}
        />
      </div>
      {obj?.moduleName === 'productIdentifier' && (
        <>
          <div className="common-react-select">
            <p className="field-name">
              {t('DPP.CONTROL.SOURCE.OUTPUT')} <span className="p-0">*</span>
            </p>
            <Select
              placeholder={t('DPP.CONTROL.SOURCE.SELECT_OUTPUT')}
              options={productIdentifierOutput || []}
              styles={customStyles}
              className="common-select"
              classNamePrefix="common-select"
              getOptionLabel={({ label }) => `${label}`}
              getOptionValue={({ value }) => `${value}`}
              value={productIdentifierOutput?.[0] || obj?.relation?.output}
              onChange={(selected) => handleSelect(selected, 'output')}
            />
          </div>
          <div className="common-react-select mb-0">
            <p className="field-name">
              {t('DPP.CONTROL.SOURCE.SUB_LOCATION')} <span className="p-0">*</span>
            </p>
            <Select
              placeholder={t('DPP.CONTROL.SOURCE.SELECT_SUB_LOCATION')}
              options={productIdentifierOption}
              styles={customStyles}
              className="common-select"
              classNamePrefix="common-select"
              getOptionLabel={({ name }) => `${name}`}
              getOptionValue={({ _id }) => `${_id}`}
              value={productIdentifierOption?.find((datas) => datas._id === obj?.relation?.subLocation) || null}
              onChange={(selected) => handleSelect(selected, 'subLocation')}
            />
          </div>
        </>
      )}
    </>
  );
}

export default SourceSetting;
